import * as Yup from "yup";
const ForgotPasswordValidation = Yup.object().shape({
  email: Yup.string().email("Invalid Email").required("Email is required!"),
});

export default ForgotPasswordValidation;
